import request from './request'
import type { LoginRequest, LoginResponse, ApiResponse, User, AdminListResponse } from '@/types/auth'

// 登录
export const login = (data: LoginRequest): Promise<LoginResponse> => {
  return request.post('/admin/login', data)
}

// 登出
export const logout = (): Promise<ApiResponse> => {
  return request.post('/admin/logout')
}

// 获取当前用户信息
export const getProfile = (): Promise<ApiResponse<User>> => {
  return request.get('/admin/profile')
}

// 获取管理员列表
export const getAdmins = (params?: {
  page?: number
  page_size?: number
  order_by?: string
  order?: string
}): Promise<AdminListResponse> => {
  return request.get('/admin', { params })
}

// 创建管理员
export const createAdmin = (data: {
  username: string
  password: string
  role?: string
}): Promise<ApiResponse> => {
  return request.post('/admin', data)
}

// 更新管理员
export const updateAdmin = (id: number, data: {
  username?: string
  password?: string
  role?: string
}): Promise<ApiResponse> => {
  return request.put(`/admin/${id}`, data)
}

// 删除管理员
export const deleteAdmin = (id: number): Promise<ApiResponse> => {
  return request.delete(`/admin/${id}`)
}

// 获取安全日志
export const getSecurityLogs = (params?: {
  page?: number
  page_size?: number
}): Promise<ApiResponse> => {
  return request.get('/admin/security/logs', { params })
}

// 获取锁定账户
export const getLockedAccounts = (): Promise<ApiResponse> => {
  return request.get('/admin/security/locked-accounts')
}

// 获取封禁IP
export const getBlockedIPs = (): Promise<ApiResponse> => {
  return request.get('/admin/security/blocked-ips')
}

// 解锁账户
export const unlockAccount = (data: { username: string }): Promise<ApiResponse> => {
  return request.post('/admin/security/unlock-account', data)
}

// 解封IP
export const unblockIP = (data: { ip: string }): Promise<ApiResponse> => {
  return request.post('/admin/security/unblock-ip', data)
}

// 清理安全日志
export const cleanupSecurityLogs = (): Promise<ApiResponse> => {
  return request.post('/admin/security/cleanup')
}
